import {Component, NgZone, OnInit} from '@angular/core';
import { App, URLOpenListenerEvent } from '@capacitor/app';
import { Router } from "@angular/router";
import {Client} from "@mlc/types";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {UserService} from "./core/services/user/user.service";
import {BreakpointObserver, Breakpoints} from "@angular/cdk/layout";
import { SplashScreen } from '@capacitor/splash-screen';
import * as LiveUpdates from '@capacitor/live-updates';
import { environment } from 'src/environments/environment';
import { Capacitor } from '@capacitor/core';
import { PlatformEnum } from './core/models/enums/platform.enum';

@UntilDestroy()
@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  public user: Client | undefined = undefined;
  public isMdScreen = false;
  constructor (
    private breakpointObserver: BreakpointObserver,
    private router: Router,
    private zone: NgZone,
    private userService: UserService
  ) {
  }

  async ngOnInit () {
    await this.handleLiveUpdateSync();
    this.initializeApp();
    await this.userService.init();
    this.userService
      .get()
      .pipe(
        untilDestroyed(this)
      )
      .subscribe({
        next: (user: Client | undefined) => {
          this.user = user;
        },
      });
    this.breakpointObserver.observe([Breakpoints.Medium, Breakpoints.Large, Breakpoints.XLarge])
      .pipe(untilDestroyed(this))
      .subscribe(
      isMd => {
        this.isMdScreen = isMd.matches
      }
    )
  }

  async handleLiveUpdateSync() {
    if (Capacitor.getPlatform() === PlatformEnum.WEB) return;
    await LiveUpdates.setConfig({
      channel: environment.APPFLOW_ENV,
      appId: environment.APPFLOW_ID
    });

    const result = await LiveUpdates.sync();
    if (result.activeApplicationPathChanged) {
      await LiveUpdates.reload();
    } else {
      await SplashScreen.hide();
    }
  }

  initializeApp() {
    App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
      this.zone.run(() => {
        const slug = event.url.split(".app").pop();
        if (slug) {
          this.router.navigateByUrl(slug);
        }
      });
    });
  }
}
